import script from "./TextToggle.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextToggle.vue?vue&type=script&setup=true&lang=ts"

import "./TextToggle.vue?vue&type=style&index=0&id=75364fa2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75364fa2"]])

export default __exports__